import { createSlice } from '@reduxjs/toolkit'
import { getAllRatings, getMyRatings, rateRecipe, } from './ratingThunk'

const initialRatingState = {
  allRatings: [],
  ratedRecipe: {},
  status: null
}

const ratingSlice = createSlice({
  name: 'rating',
  initialState: initialRatingState,
  extraReducers: {
    // *************************
    // getMyRatings
    // *************************
    [getMyRatings.pending]: (state) => {
      state.status = 'pending'
    },
    [getMyRatings.fulfilled]: (state, { payload }) => {
      state.status = 'success'
      state.allRatings = payload
    },
    [getMyRatings.rejected]: (state) => {
      state.status = 'failed'
      state.allRatings = []
    },
    // *************************
    // getAllRatings
    // *************************
    [getAllRatings.pending]: (state) => {
      state.status = 'pending'
    },
    [getAllRatings.fulfilled]: (state, { payload }) => {
      state.status = 'success'
      state.allRatings = payload
    },
    [getAllRatings.rejected]: (state) => {
      state.status = 'failed'
      state.allRatings = []
    },
    // *************************
    // rateRecipe
    // *************************
    [rateRecipe.pending]: (state) => {
      state.status = 'pending'
    },
    [rateRecipe.fulfilled]: (state, { payload }) => {
      state.status = 'success'
      state.ratedRecipe = payload
    },
    [rateRecipe.rejected]: (state) => {
      state.status = 'failed'
      state.ratedRecipe = {}
    },
  }
})

export const selectStatus = (state) => state.rating.status

export default ratingSlice.reducer
